import { useQuery } from '@tanstack/react-query'
import { warehouseApis } from '../gateways/breadstack/warehouseApis'
import type { WHLocation } from '../types/warehouse'

interface UseWarehousesOptions {
  enabled?: boolean
  // Include pantry warehouses without a `pos_id` (unlink-POS manual product flow).
  includeUnlinkPos?: boolean
}

export const useWarehouses = (
  storeId: string,
  organizationId?: string,
  options: UseWarehousesOptions = {},
) =>
  useQuery<WHLocation[]>({
    queryKey: ['warehouses', storeId, organizationId, options.includeUnlinkPos ?? false],
    queryFn: () => warehouseApis.getList(storeId, organizationId, options.includeUnlinkPos),
    enabled: Boolean(storeId) && (options.enabled ?? true),
    initialData: [],
  })
